module.exports = __webpack_public_path__ + "static/media/info-basica-comprobantes-electronicos.c337c59a.pdf";